import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-video\">\r\n<title>file_video</title>\r\n<path fill=\"#9675f4\" d=\"M7.333 0.667h14l8 8v18c0 2.2-1.8 4-4 4h-18c-2.2 0-4-1.8-4-4v-22c0-2.2 1.8-4 4-4zM16.333 25.667c4.4 0 8-3.6 8-8s-3.6-8-8-8c-4.4 0-8 3.6-8 8s3.6 8 8 8zM16.333 23.667c-3.4 0-6-2.6-6-6s2.6-6 6-6c3.4 0 6 2.6 6 6s-2.6 6-6 6zM19.333 18.267l0.2-0.2c0.2-0.4 0.2-0.8-0.2-1l-3.8-2.6c0 0-0.2-0.2-0.4-0.2-0.4 0-0.8 0.4-0.8 0.8v5c0 0.2 0 0.4 0.2 0.4 0.2 0.4 0.8 0.4 1.2 0.2l3.6-2.4z\" />\r\n<path fill=\"#e0e0e0\" opacity=\"0.619\" d=\"M21.333 0.667l8 8h-6c-1.2 0-2-0.8-2-2v-6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/video.svg
// module id = 3JNx
// module chunks = 14